
/**
 * Logger Utility
 * Creates a namespaced logger for a given module.
 * Usage: const log = window.createLogger('MyModule');
 *        log.log('message', data);   → console.log('[MyModule]', 'message', data)
 *        log.warn('oops', err);      → console.warn('[MyModule]', 'oops', err)
 *        log.error('failed', err);   → console.error('[MyModule]', 'failed', err)
 *        log.info('detail', data);   → console.info('[MyModule]', 'detail', data)
 *        log.debug('trace', data);   → console.debug('[MyModule]', 'trace', data)
 */
(function () {
  function createLogger(moduleName) {
    const prefix = "[" + moduleName + "]";
    return {
      log: function () {
        console.log.apply(
          console,
          [prefix].concat(Array.prototype.slice.call(arguments)),
        );
      },
      warn: function () {
        console.warn.apply(
          console,
          [prefix].concat(Array.prototype.slice.call(arguments)),
        );
      },
      error: function () {
        console.error.apply(
          console,
          [prefix].concat(Array.prototype.slice.call(arguments)),
        );
      },
      info: function () {
        console.info.apply(
          console,
          [prefix].concat(Array.prototype.slice.call(arguments)),
        );
      },
      debug: function () {
        console.debug.apply(
          console,
          [prefix].concat(Array.prototype.slice.call(arguments)),
        );
      },
    };
  }

  window.createLogger = createLogger;
})();
